"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgCartSolid(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M8.826 19.726a2.067 2.067 0 110 4.134 2.067 2.067 0 010-4.134zm11.967 0a2.067 2.067 0 110 4.134 2.067 2.067 0 010-4.134zM3.557 1c.779 0 1.464.498 1.712 1.225l.043.148.855 3.45h16.024c.95 0 1.728.73 1.803 1.66l.006.149c0 .098-.008.195-.024.292l-.03.143-1.88 7.58a1.809 1.809 0 01-1.6 1.366l-.155.007H8.764c-.78 0-1.465-.498-1.712-1.225l-.044-.149-3.2-12.9a.258.258 0 00-.182-.186l-.07-.01H.777A.775.775 0 01.67 1.007L.775 1h2.782z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgCartSolid;
exports.default = _default;